jQuery(function ($) {
    $(document).ready(function () {

        if ($(".single-product-mobile-gallery-swiper").length > 0) {
            const mobileGalleryThumbnailsSwiper = new Swiper('.single-product-mobile-gallery-thumbnails-swiper', {
                slidesPerView: 4,
                spaceBetween: 15,
                loop: false,
                freeMode: false,
                preloadImages: false,
                lazy: true,
                navigation: {
                    nextEl: ".single-product-mobile-gallery-thumbnails-swiper-button-next",
                    prevEl: ".single-product-mobile-gallery-thumbnails-swiper-button-prev",
                },
                breakpoints: {
                    640: {
                        slidesPerView: 6,
                        spaceBetweenSlides: 20,
                    },
                }
            });

            const mobileGallerySwiper = new Swiper('.single-product-mobile-gallery-swiper', {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                freeMode: false,
                thumbs: {
                    swiper: mobileGalleryThumbnailsSwiper,
                },
            });

            const mobileGalleryLightboxSwiper = new Swiper('.single-product-mobile-gallery-lightbox-swiper', {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                freeMode: false,
                preloadImages: false,
                lazy: true,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: ".single-product-mobile-gallery-lightbox-swiper-button-next",
                    prevEl: ".single-product-mobile-gallery-lightbox-swiper-button-prev",
                }
            });

            const modal = document.getElementById("lightbox");

            mobileGalleryAutoplay('.single-product-mobile-gallery-swiper');

            /**
             * Enlarge gallery content (open in modal window)
             */
            $(document).on('click', '.slide-enlarge', function ()  {
                modal.classList.remove('hidden');
                modal.classList.add('flex');

                mobileGalleryAutoplay('.single-product-mobile-gallery-lightbox-swiper');

                mobileGalleryLightboxSwiper.slideTo(mobileGallerySwiper.activeIndex);
                $('.slides-count').text(`${mobileGallerySwiper.realIndex + 1} / ${$('.slide-img').length - 2}`);

                mobileGalleryLightboxSwiper.on('slideChange', function() {
                    $('.slides-count').text(`${mobileGalleryLightboxSwiper.realIndex + 1} / ${$('.slide-img').length - 2}`);
                });
            });

            /**
             * Close gallery and pause all videos if any are playing
             */
            $(document).on('click', '.ligtbox-close', function () {
                const videos = document.querySelectorAll('.single-product-mobile-gallery-lightbox-swiper video');

                if (videos.length > 0) {
                    videos.forEach((video) => video.pause());
                }

                modal.classList.remove('flex');
                modal.classList.add('hidden');
            });
        }

        /**
         * Get videos located inside target container and play them when they are currently displayed.
         *
         * @param targetContainer
         */
        function mobileGalleryAutoplay(targetContainer) {
            const videos = document.querySelectorAll(`${targetContainer} video`);
            const videoVolume = 0.7;

            jQuery(window).bind("click keydown touch", detectInteraction);

            function detectInteraction(){
                jQuery(window).unbind("click keydown touch");

                if (document.querySelector(`${targetContainer} .swiper-slide-active video`)) {
                    videos[1].play();
                    videos[1].volume = videoVolume;
                }
            }

            const targetNode = document.querySelector(`${targetContainer} .swiper-wrapper`);

            const observer = new MutationObserver(function (mutationsList, observer) {
                for (const mutation of mutationsList) {
                    if (mutation.target.classList.contains('swiper-slide') && mutation.target.querySelector('video')) {
                        if (mutation.target.classList.contains('swiper-slide-active')) {
                            setTimeout(() => {
                                mutation.target.querySelector('video').play();
                                mutation.target.querySelector('video').volume = videoVolume;
                            },200)
                        } else {
                            mutation.target.querySelector('video').pause();
                        }
                    }
                }
            });

            const config = {attributes: true, attributeFilter: ['class'], subtree: true};

            observer.observe(targetNode, config);
        }
    });
});